// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as ChevronUpComponent} from './ChevronUp.svg';

import Icon, { TIconProps } from '../Icon';

export const IconChevronUp = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <ChevronUpComponent/>
  </Icon>
));
